module.exports = {

    //registerCustomer
    
    FETCH_REGISTRATION_DATA: 'FETCH_REGISTRATION_DATA',
    GET_ERRORS: 'GET_ERRORS',

}